module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAQAAABIkb+zAAABGElEQVR4Ae3atUFFQQAF0SkBdy0H7wCPsWZogA5wKATLcXdf3OW7z9xwo/MkW2LIzMzMzEKKJ0CAAAECBAgQIECAgOwAmFkpA0yzzCkhzTthmSkGKSbuGhnnmpDhXTFOHXHUxQUhS3ZBFzE2TMiyDRND7dxnHeCeTqKshjNCFu6cWqJqgpClmyByNBOyeM1EbIyQ4W3QStnjOtggfNsYEVsgZHT7VPNWNXvfTheJ2FqGAX18rvfb6RoRO8swoJ7P1Xw7PSViIcOr4XN1hG/LekAPn+vLPcD2l594P/cAgU3aKaeMdjYJ2Q+IPAECBAgQkM2ARBMgQIAAAQIECMgaQORSDkh5AhAgQIAAb2wJECBAgAAzMzMzewBJHEKzAI3uPQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/image/baseline_print_black.png
// module id = 322
// module chunks = 0